import { MSAData, SecondaryStructure } from '../types';

export class DataLoader {
  /**
   * Load MSA data from API URL
   */
  static async loadMSAData(apiUrl: string): Promise<MSAData & { notation?: SecondaryStructure }> {
    try {
      const response = await fetch(apiUrl);
      
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      
      const jsonResponse = await response.json();
      
      // Check if the API returned an error
      if (jsonResponse.status === 'error') {
        throw new Error(jsonResponse.message || 'API returned an error');
      }
      
      // Extract the data from the API response
      const data = jsonResponse.data;
      if (!data) {
        throw new Error('No data in API response');
      }
      
      // Return the MSA data in the expected format
      const msaData: MSAData & { notation?: SecondaryStructure } = {
        sequences: data.sequences || [],
        consensus: data.consensus || undefined,
        notation: data.notation || undefined,
        sequenceCount: data.sequenceCount || (data.sequences || []).length
      };
      
      return msaData;
      
    } catch (error) {
      if (error instanceof Error) {
        throw new Error(`Failed to load MSA data: ${error.message}`);
      }
      throw new Error('Failed to load MSA data: Unknown error');
    }
  }
}